import Backbone from '@polleverywhere/backbone'
import Tpl from './tpl.hamlc'

export default class Full extends Backbone.View {
  get className () { return 'full ' }

  initialize (options = {}) {
    if (!options.i18n) {
      console.error('i18n is required.')
    }

    this.i18n = options.i18n
    this.render = this.render.bind(this)
  }

  render () {
    this.$el
      .html(Tpl())
      .append(this.i18n('Poll is full and no longer accepting responses'))
    return this
  }
}
